export const mediaWidgetImageStyle = {
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    objectFit: 'cover'
};